<template>
  <div class="ion-padding modal-content ion-text-center">
    <modal-close />
    <roodie fillOuter="#5E58BE" :expression="'happy'" />
    <div class="u-color-primary u-medium ion-margin-top">
      <b>
        Machen Sie den Roodie.Check:
      </b>
      <p>
        Geben Sie Ihre Beschwerden an und teilen Sie diese mit den Experten
        schon im Vorfeld, damit Sie gezielt für Sie suchen können.
      </p>
      <div class="ion-margin-bottom">
        <img width="150" src="@/assets/img/header/icon_betterdoc.svg" />
      </div>
      <ion-button
        fill="outline"
        @click="modalController.dismiss({ continue: true })"
        >Weiter</ion-button
      >
    </div>
  </div>
</template>

<script>
import { IonButton, modalController } from "@ionic/vue";
import Roodie from "@lib/components/svg/Roodie";
import ModalClose from "@lib/components/ModalClose";

export default {
  components: {
    IonButton,
    Roodie,
    ModalClose,
  },
  setup() {
    return { modalController };
  },
};
</script>

<style></style>
